import React, { Fragment, useCallback } from 'react';
import * as S from './style';
import { Label } from 'components';
import PopupImageGuide, { TGuideType, Props as PopupImageGuideProps } from 'components/molecules/Popup/ImageGuide';
import { ReactComponent as IconCamera } from 'assets/img/common/ic_camera.svg';
import { LABEL_PROFILE_IMG } from 'commons/ZimssaString';
import { usePopup } from 'hooks';
import { GUIDE_TYPE } from 'commons/ZimssaConstant';

export interface Props {
    value?: string;
    name?: string;
    subName?: string;
    phone?: string;
    isCaption?: boolean;
    isUpload?: boolean;
    type?: TGuideType;
    inputName?: string;
    imgDir?: string;
    onChangeHandler?: (type: any, value: string) => void;
}

function FormProfile({ value, name, subName, phone, isCaption, isUpload = false, type, inputName, imgDir, onChangeHandler }: Props): React.ReactElement {
    const { isShow, popupAction } = usePopup();

    const onClickCallback = useCallback(
        () => {
            popupAction();
        },
        [popupAction]
    );

    const popupImageGuideProps: PopupImageGuideProps = {
        type: type ? type : GUIDE_TYPE.PROFILE,
        inputName: inputName ? inputName : '',
        imgDir: imgDir ? imgDir : '',
        isShow: isShow,
        onClickPopupAction: popupAction,
        onChangeHandler: (type: any, value: string) => {
            onChangeHandler && onChangeHandler(type, value);
            popupAction();
        },
    };

    return (
        <Fragment>
            {isUpload ? <PopupImageGuide {...popupImageGuideProps} /> : null}
            <S.ProfileContainer>
                {isCaption ? <Label contents={LABEL_PROFILE_IMG} fontStyle={'caption'} color={'gray_opacity_600'} /> : null}
                <S.FromProfileImage size={'XL'} background={value} onClick={onClickCallback} icon={isUpload ? <IconCamera /> : undefined} />
                {name || phone ? (
                    <S.LabelWrapper>
                        {name ? (<S.LabelWIthSubName>
                                    <Label contents={name} fontStyle={'body2_bold'} color={'gray_opacity_800'}></Label>
                                    {subName ? <S.SubName>{subName}</S.SubName> : null}
                                </S.LabelWIthSubName>) : null}
                        {phone ? <Label contents={phone} fontStyle={'body2'} color={'gray_opacity_600'} /> : null}
                    </S.LabelWrapper>
                ) : null}
            </S.ProfileContainer>
        </Fragment>
    );
}

export default FormProfile;
